export const SET_SEO = 'SET_SEO';
export const SET_TRANSLATE = 'SET_TRANSLATE';
export const SET_CATEGORY_BLOG = 'SET_CATEGORY_BLOG';

export const setSeoMeta = (seoObject) => {
    return {
        type: SET_SEO,
        seo: seoObject
    }
}

export const setTranslation = (locale) => {
    return {
        type: SET_TRANSLATE,
        locale
    }
}

export const setCategoryBlog = (category) => {
    return{
        type: SET_CATEGORY_BLOG,
        activeCategory: category
    }
}